import { getCheckout, State as CheckoutState } from "./checkout";
import { OfferingPagesState, OfferingState, OfferingType } from "../../../../../models/state";

export type State = CheckoutState;
export const getPreSelectedOffering: (state: State) => string | undefined = (state) =>
    getCheckout(state).preSelectedOffering;
export const getOfferingsForCart: (state: State) => OfferingState = (state: State) =>
    getCheckout(state).offerings || [];
export const getOfferingPages: (state: State) => OfferingPagesState[] = (state) =>
    getCheckout(state).offeringPages || [];
export const getOfferingType: (state: State) => OfferingType = (state) => getCheckout(state).offeringType || null;
